import "./SearchFilterComp.css";
import { defineComponent as m, resolveComponent as l, openBlock as r, createElementBlock as d, normalizeClass as h, createBlock as p, withCtx as a, createVNode as t, renderSlot as f, createCommentVNode as y } from "vue";
import { IconComp as V } from "./IconComp.js";
import { ButtonComp as _ } from "./ButtonComp.js";
import { SelectItemComp as b } from "./SelectItemComp.js";
import { InputComp as C } from "./InputComp.js";
import { _ as g } from "./_plugin-vue_export-helper.dad06003.js";
const w = m({
  events: {
    "update:modelValue": {
      type: Object,
      Note: "Emits selected object and input back"
    }
  },
  components: {
    IconComp: V,
    ButtonComp: _,
    SelectItemComp: b,
    InputComp: C
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return {
          search: "",
          filter: {}
        };
      }
    },
    options: {
      type: Array,
      required: !0
    },
    filterWidth: {
      type: String,
      default: "max-content"
    },
    selectWidth: {
      type: String,
      default: "230px"
    },
    placeHolder: {
      type: String
    },
    disableDropDown: {
      type: Boolean
    },
    disableInput: {
      type: Boolean
    },
    useMagnifyIcon: Boolean,
    autofocus: Boolean
  },
  data() {
    return {
      open: !1
    };
  },
  computed: {
    classObject() {
      return {
        searchFilter: !0
      };
    },
    searchValue: {
      get() {
        return this.modelValue.search;
      },
      set(e) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          search: e
        });
      }
    },
    filterValue: {
      get() {
        return this.modelValue.filter;
      },
      set(e) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          filter: e
        });
      }
    },
    showCloseIcon() {
      return !!this.modelValue.search;
    },
    showMagnifyIcon() {
      return this.useMagnifyIcon && !this.open;
    }
  },
  methods: {
    clearSearch() {
      this.searchValue = "";
    },
    enterKeyPressed() {
      this.$emit("enterKeyPressed");
    }
  }
});
const I = {
  key: 1,
  class: "searchFilter__container"
};
function k(e, o, B, F, S, $) {
  const n = l("icon-comp"), i = l("button-comp"), c = l("select-item-comp"), u = l("input-comp");
  return r(), d("div", {
    class: h(e.classObject)
  }, [
    e.showMagnifyIcon ? (r(), p(i, {
      key: 0,
      medium: "",
      onClick: o[0] || (o[0] = (s) => e.open = !0)
    }, {
      default: a(() => [
        t(n, { icon: "search_small" })
      ]),
      _: 1
    })) : (r(), d("div", I, [
      t(c, {
        id: "searchFilterDropdown",
        medium: "",
        selectGray: "",
        disableMessages: "",
        modelValue: e.filterValue,
        "onUpdate:modelValue": o[1] || (o[1] = (s) => e.filterValue = s),
        options: e.options,
        width: e.filterWidth,
        disabled: e.disableDropDown
      }, null, 8, ["modelValue", "options", "width", "disabled"]),
      t(u, {
        medium: "",
        disableMessages: "",
        id: "searchFilter",
        modelValue: e.searchValue,
        "onUpdate:modelValue": o[2] || (o[2] = (s) => e.searchValue = s),
        placeholder: e.placeHolder,
        width: e.selectWidth,
        disabled: e.disableInput,
        autofocus: e.autofocus,
        onEnterKeyPressed: e.enterKeyPressed
      }, {
        prepend: a(() => [
          t(n, {
            class: "searchFilter--cursor",
            icon: "search_small"
          })
        ]),
        append: a(() => [
          f(e.$slots, "append", {}, () => [
            e.showCloseIcon ? (r(), p(i, {
              key: 0,
              class: "searchFilter__clearButton",
              blank: "",
              onClick: e.clearSearch
            }, {
              default: a(() => [
                t(n, {
                  class: "searchFilter--cursor",
                  icon: "close_small"
                })
              ]),
              _: 1
            }, 8, ["onClick"])) : y("", !0)
          ], !0)
        ]),
        _: 3
      }, 8, ["modelValue", "placeholder", "width", "disabled", "autofocus", "onEnterKeyPressed"])
    ]))
  ], 2);
}
const O = /* @__PURE__ */ g(w, [["render", k], ["__scopeId", "data-v-f8aa8745"]]);
export {
  O as SearchFilterComp
};
//# sourceMappingURL=SearchFilterComp.js.map
